<div @swipeAnimation *ngIf="showComponent">
  <ng-container *ngIf="offer != null && offer.premium != null; else loading">
    <div id="offer-details-body" class="d-flex flex-column vh-100"
    style="padding-left: 2rem;">
      <ng-scrollbar visibility="hover">
        <div
          class="pt-3 d-flex min-vh-100 flex-column h-100 top-main-container">

        <div>
          <ng-container *ngTemplateOutlet="titleTemplate"></ng-container>
        </div>
        <div class="d-flex flex-row main-container">
          <div class="d-flex flex-column flex-shrink-1 left-container offer-creator-name w-100 h-100 title-tile-container">
            <div class="mt-4">
            {{ 'offerPreview.title2' | translate }}
            {{ (this.user$|async).firstName }} {{ (this.user$|async).lastName }}
            </div>
            <div class="mt-2">
                <hr>
            <app-offer-tile [offers]="[offer]" [(selectedOffer)]="offer"
              [insuredAmount]="insuredAmount"
            ></app-offer-tile>
              <hr>
            </div>
            <div class="w-100 h-100 body-container mt-2">
              <div class="flex-column selected" style="width: 100%">
                <div class="open-details d-flex align-items-center mb-3">
              <span class="open-all-label">
                {{ (!allExpandState ? 'createOffer.openDetails' : 'createOffer.closeDetails') | translate }}
              </span>
                  <mat-slide-toggle [(ngModel)]="allExpandState"
                                    (ngModelChange)="clickButton($event)"></mat-slide-toggle>
                </div>
                <mat-accordion class="accordion-container" [multi]="true" displayMode="flat">
                    <mat-expansion-panel *ngIf="offer.offerType === OfferType.EXTERNAL_COVERAGE" [togglePosition]="'before'">
                        <mat-expansion-panel-header [@.disabled]="true">
                            <mat-panel-title>
                                {{'offer.data' | translate}}
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="d-flex proposal-details-row">
                            <div class="info-col">{{'offer.name' | translate}}:</div>
                            <div>{{offer.externalInsurer.name}}</div>
                        </div>
                        <div class="d-flex proposal-details-row">
                            <div class="info-col">{{'offer.streetAndNumber' | translate}}:</div>
                            <div>{{offer.externalInsurer.streetName}} {{offer.externalInsurer.houseNumber}}
                            </div>
                        </div>
                        <div class="d-flex proposal-details-row">
                            <div class="info-col">{{'offer.postalCodeAndLocation' | translate}}:</div>
                            <div>{{offer.externalInsurer.postalCode}} {{offer.externalInsurer.location}}</div>
                        </div>

                        <div class="d-flex proposal-details-row">
                            <div class="info-col">{{'proposalDetails.lkz' | translate}}, {{'proposalDetails.country' | translate}}:
                            </div>
                            <div>{{offer.externalInsurer.countryCode}},
                                {{'countryCodes.' + offer.externalInsurer.countryCode |translate }}</div>
                        </div>
                    </mat-expansion-panel>
                    <hr *ngIf="offer.offerType === OfferType.EXTERNAL_COVERAGE" style="width: 50%">
                    <mat-expansion-panel [togglePosition]="'before'">
                    <mat-expansion-panel-header [@.disabled]="true">
                      <mat-panel-title>
                        {{ 'offer.managementBusiness' | translate }}
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="d-flex proposal-details-row">
                      <div class="info-col">{{ 'offer.share' | translate }} ({{ 'offer.inPercent' | translate }}):</div>
                      <div>{{ offer.amountCovered |percent: '1.2-2' }}
                      </div>
                    </div>
                    <div class="d-flex proposal-details-row">
                      <div class="info-col">{{ 'offer.role' | translate }}:</div>
                      <div>{{ (offer.isLeading ? 'offer.leadInsurer' : 'offer.followingInsurer') | translate }}</div>
                    </div>
                  </mat-expansion-panel>
                  <hr *ngIf="offer.offerType != OfferType.EXTERNAL_COVERAGE" style="width: 50%">
                  <mat-expansion-panel [togglePosition]="'before'">
                    <mat-expansion-panel-header [@.disabled]="true">
                      <mat-panel-title>
                        {{ 'offer.premium' | translate }}
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="d-inline-flex proposal-details-row">
                      <div class="info-col">{{ 'offer.createOffer.referenceValue' | translate }}:</div>
                      <div
                        *ngIf="offer.referenceValue">{{ 'proposalDetails.createOfferTab.referenceValues.' + offer.referenceValue | translate }}
                      </div>
                    </div>
                    <div *ngIf="offer.premiumInPercent != null && offer.premiumInPercent != 0" class="d-flex proposal-details-row">
                      <div class="info-col">{{ 'offer.inPercent' | translate }}:</div>
                      <div>{{ offer.premiumInPercent |percent: '1.2-2' }}</div>
                    </div>
                    <div *ngIf="offer.premiumPerThousand != null && offer.premiumPerThousand != 0" class="d-flex proposal-details-row">
                      <div class="info-col">{{ 'offer.perThousand' | translate }}:</div>
                      <div>{{ offer.premiumPerThousand |permilleFormat }}</div>
                    </div>
                    <div class="d-flex proposal-details-row">
                      <div class="info-col">{{ 'offer.premium' | translate }}:</div>
                      <div>{{ offer.premium |currency:offer.currency }}</div>
                    </div>
                    <div class="d-flex proposal-details-row">
                      <div class="info-col">{{ 'offer.expectedTotalPremium' | translate }}:</div>
                      <div>{{ offer.expectedTotalPremium |currency:offer.currency }}</div>
                    </div>
                    <div class="d-flex proposal-details-row" *ngIf="offer.advancePremium">
                      <div class="info-col">{{ 'offer.advancePremium' | translate }}:</div>
                      <div *ngIf="offer.advancePremium">{{ offer.advancePremium |currency:offer.currency }}</div>
                    </div>
                    <div class="d-flex proposal-details-row" *ngIf="offer.minimumPremium">
                      <div class="info-col">{{ 'offer.minimumPremium' | translate }}:</div>
                      <div *ngIf="offer.minimumPremium">{{ offer.minimumPremium |currency:offer.currency }}</div>
                    </div>
                    <div class="d-flex proposal-details-row">
                      <div class="info-col">{{ 'proposalDetails.createOfferTab.typeOfDeductible' | translate }}:</div>
                      <div
                        *ngIf="offer.typeOfDeductible">{{ "proposalDetails.createOfferTab.typeOfDeductibleOptions." + offer.typeOfDeductible | translate }}
                      </div>
                    </div>
                    <div *ngIf="offer.typeOfDeductible != QuestionOptions.typeOfDeductible[0]"
                         class="d-flex proposal-details-row">
                      <div class="info-col">{{ 'proposalDetails.createOfferTab.deductibleAbsoluteAmount' | translate }}:
                      </div>
                      <div>{{ offer.deductibleAbsoluteAmount |currency:offer.deductibleCurrency }}</div>
                    </div>
                  </mat-expansion-panel>
                  <hr style="width: 50%">

                  <ng-container *ngIf="offer.offerType != OfferType.EXTERNAL_COVERAGE">
                    <mat-expansion-panel [disabled]="offer.standardTermsAndConditions == null || offer.standardTermsAndConditions.length == 0"
                                         [togglePosition]="'before'">
                      <mat-expansion-panel-header [@.disabled]="true">
                        <mat-panel-title>
                          {{ 'offer.defaultTerms' | translate }}
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <div class="pre-wrap">
                        - {{ offer.standardTermsAndConditions?.join('\n - ') }}
                      </div>
                    </mat-expansion-panel>
                    <hr style="width: 50%">
                    <mat-expansion-panel [disabled]="offer.individualTermsAndConditions == 0"
                                         [togglePosition]="'before'">
                      <mat-expansion-panel-header [@.disabled]="true">
                        <mat-panel-title>
                          {{ 'offer.individualTerms' | translate }}
                        </mat-panel-title>
                      </mat-expansion-panel-header>

                      <div class="pre-wrap">{{ offer.individualTermsAndConditions }}
                      </div>
                    </mat-expansion-panel>
                    <hr style="width: 50%">
                    <mat-expansion-panel [disabled]="offer.standardClauses == null || offer.standardClauses.length == 0" [togglePosition]="'before'">
                      <mat-expansion-panel-header [@.disabled]="true">
                        <mat-panel-title>
                          {{ 'offer.defaultClauses' | translate }}
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <div class="pre-wrap">
                        - {{ offer.standardClauses?.join('\n - ') }}
                      </div>
                    </mat-expansion-panel>
                    <hr *ngIf="offer.offerType != OfferType.EXTERNAL_COVERAGE" style="width: 50%">
                    <mat-expansion-panel [disabled]="offer.individualClauses == 0" [togglePosition]="'before'">
                      <mat-expansion-panel-header [@.disabled]="true">
                        <mat-panel-title>
                          {{ 'offer.individualClauses' | translate }}
                        </mat-panel-title>
                      </mat-expansion-panel-header>

                      <div class="pre-wrap">{{ offer.individualClauses }}
                      </div>
                    </mat-expansion-panel>
                    <hr class="line" style="width: 50%">
                    <mat-expansion-panel [disabled]="offer.otherInformation == 0" [togglePosition]="'before'">
                      <mat-expansion-panel-header [@.disabled]="true">
                        <mat-panel-title>
                          {{ 'offer.createOffer.individualInformationSection.otherInformation' | translate }}
                        </mat-panel-title>
                      </mat-expansion-panel-header>

                      <div class="pre-wrap">{{ offer.otherInformation }}
                      </div>
                    </mat-expansion-panel>
                  </ng-container>
                  <hr style="width: 50%">
                  <mat-expansion-panel [disabled]="offer.attachedFiles?.length === 0" [togglePosition]="'before'">
                    <mat-expansion-panel-header [@.disabled]="true">
                      <mat-panel-title>
                        {{ 'offer.files' | translate }}
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <app-download-files [attachedFiles]="offer.attachedFiles">
                    </app-download-files>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
            </div>
          </div>
        </div>
        </div>
      </ng-scrollbar>
    </div>
  </ng-container>


</div>

<ng-template #loading>
  <div class="d-flex justify-content-center align-items-center h-100 w-100 pt-4">
    <mat-spinner class="mt-4 loading-spinner"></mat-spinner>
  </div>
</ng-template>
<ng-template #titleTemplate>
  <div class="d-flex flex-row justify-content-between title-container">
    <div class="d-flex flex-column">
        <div (click)="back()" class="back">
            <mat-icon>arrow_backward</mat-icon>
            {{'nav.back' | translate}}</div>
      <div class="offer-preview-title">
        <ng-container *ngIf="true">{{ (offer.offerType == OfferType.EXTERNAL_COVERAGE ? 'createOffer.external.preview.title' : 'offerPreview.title') |translate }}</ng-container>
      </div>
      <div class="offer-preview-subtitle">{{ (offer.offerType == OfferType.EXTERNAL_COVERAGE ? 'createOffer.external.preview.subtitle' :'offerPreview.subtitle') |translate }}</div>
    </div>
    <div class="d-flex justify-content-between align-items-end buttons-container">
      <button class="menu-button save-offer-button cursor-pointer ms-4"
              (click)="cancel()">{{ 'cancel'|translate }}
      </button>
      <button class="save-button menu-button save-offer-button cursor-pointer ms-4"
              (click)="openConfirmationMatDialog()">{{ (offer.offerType == OfferType.EXTERNAL_COVERAGE ? 'createOffer.external.addExternalCoverage' : 'offerPreview.saveOffer') | translate }}
      </button>
    </div>
  </div>
</ng-template>


<!--

-->

